const e = typeof window != "undefined", n = e && window.screen.width <= 768;
export {
  e as HAS_WINDOW,
  n as isMobile
};
